export default __webpack_public_path__ + "static/media/bell-notifs-black.7569e63f.svg";